import { useState, useEffect } from "react";
import { menuItems } from "../json/SideBarItems.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const globalCache = {
  lastUserEmail: null,
  lastUserRole: null,
  data: null,
  promise: null,
  isLoading: false,
};

const boardsToFilter = ["MASTER DESIGN", "COMPAO PRODUCT", "RRSS", "COMPAO BRANDS"];

async function fetchGroupsSingleton(userEmail, userRole) {
  const cacheKey = `${userEmail}_${userRole}`;
  const currentCacheKey = `${globalCache.lastUserEmail}_${globalCache.lastUserRole}`;

  if (cacheKey === currentCacheKey && globalCache.data) {
    return globalCache.data;
  }

  if (globalCache.promise && globalCache.isLoading) {
    return globalCache.promise;
  }

  globalCache.lastUserEmail = userEmail;
  globalCache.lastUserRole = userRole;
  globalCache.isLoading = true;

  globalCache.promise = (async () => {
    try {
      if (!userEmail) {
        globalCache.data = { filteredItems: menuItems };
        return globalCache.data;
      }

      const res = await fetch(`${backendUrl}/api/getAllGroups`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const data = await res.json();
      const userGroups = data.filter((group) =>
        group.users.some((user) => user.email === userEmail)
      );

      if (userRole === "Authenticated") {
        globalCache.data = { filteredItems: menuItems };
        return globalCache.data;
      }

      const userGroupNames = userGroups.map((g) => g.name.toUpperCase());
      const filtered = menuItems.map((section) => ({
        ...section,
        item: section.item.filter((item) => {
          const itemTitle = item.title.toUpperCase();
          return boardsToFilter.includes(itemTitle)
            ? userGroupNames.includes(itemTitle)
            : true;
        }),
      }));

      globalCache.data = { filteredItems: filtered };
      return globalCache.data;
    } catch (err) {
      console.error("Error fetching groups:", err);
      globalCache.data = { filteredItems: menuItems };
      return globalCache.data;
    } finally {
      globalCache.isLoading = false;
      globalCache.promise = null;
    }
  })();

  return globalCache.promise;
}

export function useSidebarMenuItems() {
  const [filteredMenuItems, setFilteredMenuItems] = useState(
    () => globalCache.data?.filteredItems ?? menuItems
  );

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    const userRole = localStorage.getItem("role");

    fetchGroupsSingleton(userEmail, userRole)
      .then((result) => setFilteredMenuItems(result.filteredItems))
      .catch(() => setFilteredMenuItems(menuItems));
  }, []);

  return filteredMenuItems;
}
